import { render, staticRenderFns } from "./SupportHubItem.vue?vue&type=template&id=0670e430&scoped=true&"
import script from "./SupportHubItem.vue?vue&type=script&lang=js&"
export * from "./SupportHubItem.vue?vue&type=script&lang=js&"
import style0 from "./SupportHubItem.vue?vue&type=style&index=0&id=0670e430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670e430",
  null
  
)

export default component.exports